import { PhoneNumberUtil } from 'google-libphonenumber'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { ContentType, HttpClient } from '../../../generated-api/http-client'

// const phoneUtil = PhoneNumberUtil.getInstance()

const COUNTRY_DEFAULT = 'il'

function useCountryCode(phone_number?: string): [string, Dispatch<SetStateAction<string>>] {
  const [countryCode, setCountryCode] = useState(() => {
    // if (phone_number) {
    //   const phoneNumber = phoneUtil.parse(phone_number)
    //   if (phoneNumber) {
    //     console.log('phoneNumber.getCountryCode()', phoneNumber, phoneNumber.)
    //     return COUNTRY_DEFAULT
    //   }
    // }

    return COUNTRY_DEFAULT
  })

  async function getCountryCode() {
    const client = new HttpClient()

    const userInfo = await client.request({
      path: `https://ipwhois.app/json/`,
      method: 'GET',
      type: ContentType.Json,
      format: 'json',
    })

    const { country_code } = userInfo?.data || {}
    if (country_code) {
      setCountryCode(country_code.toLowerCase())
    }
  }

  useEffect(() => {
    if (!phone_number) {
      getCountryCode()
    }
  }, [])

  return [countryCode, setCountryCode]
}

export default useCountryCode
